import(/* webpackMode: "eager" */ "/codebuild/output/src3366030061/src/github.com/bitstone/offerz-nextjs/src/app/global-error.tsx");
